<template>
  <el-dialog
    :title="title"
    :visible="dialogVisible"
    :width="width"
    :before-close="closeDialog">
    <slot></slot>
    <div class="dialog-footerex">
      <slot name="footer">
        <el-button type="primary" @click="successEv" :disabled="disableds">{{sucTxt}}</el-button>
        <el-button @click="cancelEv">{{cancelTxt}}</el-button>
      </slot>
    </div>

  </el-dialog>
</template>

<script>
export default {
  name: 'baseDialog',
  props: {
    title: {
      type: String,
      default: '提示'
    },
    disableds: {
      type: Boolean,
      default: false
    },
    sucTxt: {
      type: String,
      default: '确 定'
    },
    cancelTxt: {
      type: String,
      default: '取 消'
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    succlosedialog: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: '415px'
    }
  },
  methods: {
    cancelEv () {
      this.closeDialog()
      this.$emit('cancelEv')
    },
    successEv () {
      this.$emit('successEv')
      if (this.succlosedialog) {
        this.closeDialog()
      }
    },
    closeDialog (done) {
      this.$emit('update:dialogVisible', false)
      this.$emit('closedialogVisibale')
      done && done()
    }
  }
}
</script>

<style scoped lang="less">
/deep/.el-dialog__title{
  line-height: 20px;
  padding-left: 20px;
}
  .dialog-footerex{
    text-align: right;
  }
</style>
